import asyncRouter from '@/router/map/async.js'
import menuDemo from './menu1.js'
import parser from 'vue-common-laboratory/dist/router/parser'
// import api from "@/utils/requst.js";
import api from '@/api'

export default {
  updateSideMenuShow(dis, val) {
    dis.commit('UPDATE_SIDE_MENU_SHOW', val)
  },
  updateCollapse(dis, val) {
    dis.commit('UPDATE_COLLAPSE', val)
  },
  updateModulesMenuShow(dis, val) {
    dis.commit('UPDATE_MODULES_MENU_SHOW', val)
  },
  async getAuth(dis) {
    // 正常业务逻辑
    return api.common.getCurrUserInfo().then((res) => {
      let menus = res.data.menus
      // let menus = menuDemo.menus
      let { async, routerArr } = parser.parseAuth(menus, asyncRouter)
      menus[0].active = true
      dis.commit('UPDATE_AUTH_HAD', true)
      dis.commit('UPDATE_AUTH', async)
      dis.commit('UPDATE_SYS_LIST', menus)
      dis.commit('UPDATE_ROUTER', routerArr[0])
      dis.commit('UPDATE_UNSER_INFO', res.data)
      return false
    }).catch(err => {
      // 返回code码没有权限或其他，跳转错误页
      dis.commit('UPDATE_AUTH_HAD', true)
      dis.commit('UPDATE_AUTH', [])
    });
    /* let checkLogin = await api.common.checkLogin() //检查用户是否登陆
    let isLogin = checkLogin.data
    //判断当路由包含portal时，不请求getCurrUserInfo接口
    let params = window.location.href.split('#')
    let flag = params.length > 1 ? (params[1].includes('/portal') || params[1] == '/') : false
    // let flag = false
    if (!flag || isLogin) {
      return api.common.getCurrUserInfo().then((res) => {
        let menus = res.data.menus
        // let menus = menuDemo.menus
        let { async, routerArr } = parser.parseAuth(menus, asyncRouter)
        menus[0].active = true
        dis.commit('UPDATE_AUTH_HAD', true)
        dis.commit('UPDATE_AUTH', async)
        dis.commit('UPDATE_SYS_LIST', menus)
        dis.commit('UPDATE_ROUTER', routerArr[0])
        dis.commit('UPDATE_UNSER_INFO', res.data)
        return false
      }).catch(err => {
        // 返回code码没有权限或其他，跳转错误页
        dis.commit('UPDATE_AUTH_HAD', true)
        dis.commit('UPDATE_AUTH', [])
      });
    } else {
      dis.commit('UPDATE_AUTH_HAD', true)
      dis.commit('UPDATE_AUTH', [])
    } */

    //外网环境
    // return api.common.getCurrUserInfo().then((res) => {
    //   // let menus = res.data.menus
    //   let menus = menuDemo.menus
    //   let { async, routerArr } = parser.parseAuth(menus, asyncRouter)
    //   menus[0].active = true
    //   dis.commit('UPDATE_AUTH_HAD', true)
    //   dis.commit('UPDATE_AUTH', async)
    //   dis.commit('UPDATE_SYS_LIST', menus)
    //   dis.commit('UPDATE_ROUTER', routerArr[0])
    //   dis.commit('UPDATE_UNSER_INFO', res.data)
    //   return false
    // }).catch(err => {
    //   // 返回code码没有权限或其他，跳转错误页
    //   dis.commit('UPDATE_AUTH_HAD', true)
    //   dis.commit('UPDATE_AUTH', [])
    // });

    // 本地项目测试预览（项目开发时请注释以下代码）
    // return new Promise((reslove, reject) => {
    //   let menus = menuDemo.menus
    //   let { async, routerArr } = parser.parseAuth(menus, asyncRouter)
    //   menus[0].active = true
    //   dis.commit('UPDATE_AUTH_HAD', true)
    //   dis.commit('UPDATE_AUTH', async)
    //   dis.commit('UPDATE_SYS_LIST', menus)
    //   dis.commit('UPDATE_ROUTER', routerArr[0])
    //   reslove()
    // })
  },
  updateRouter(dis, val) {
    dis.commit('UPDATE_ROUTER', val)
  },
  updateTableQuery(dis, val) {
    dis.commit('UPDATE_TABLE_QUERY', val)
  },
  updateHeaderShow(dis, val) {
    dis.commit('UPDATE_HEADER_SHOW', val)
  },
  updateKeepAliveRoutes(dis, val) {
    dis.commit('UPDATE_KEEP_ALIVE_ROUTES', val)
  },
}




// WEBPACK FOOTER //
// ./src/vuex/actions.js